import React from 'react';
import Signature from './Signature';
import WrapComponent from '../WrapComponent';

let errorStyle= {
    fontSize: '12px',
    color: '#f44336',
    marginTop: '10px',
    textIndent: '12px'
}
class SignatureIndex extends React.Component{
    render(){
        let props = this.props;
        const { getFieldProps } = props.form;
        let fieldProps = getFieldProps(props.api_name, {
            validate: [{
                rules: [{
                    required: props.is_required,
                    message: $st(`paas.smart.form.isrequired`) 
                }, {
                    validator(rule, value, callback, source, options) {
                        value = value && value[0];

                        if (value && value.loading === 1) {
                            callback($st('正在上传签名，请稍后提交'));
                        }
                        callback();
                    }
                }],
            }]
        });
        let errorText = props.errorText;
        return (
            <div>
                <Signature {...props} {...fieldProps}></Signature>
                {errorText && <div style={errorStyle}>{errorText}</div>}
            </div>
        )
    }
}
export default WrapComponent(SignatureIndex);



// WEBPACK FOOTER //
// ./src/component/Signature/index.js